import * as React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'
import {
  FormControl,
  FormHelperText,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from '@mui/material'
import GooglePlacesAutocomplete from 'react-google-places-autocomplete'
import IdentityProofDocumentsModal from './IdentitiyProofDocumentsModal'
import { registerUser } from '../apis/userApis'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { ScaleLoader } from 'react-spinners'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  outline: 'none',
  bgcolor: 'background.paper',
  border: '2px solid #fff',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  borderRadius: '16px',
  textAlign: 'center',
  width: '350px',
}

const RegistrationModal = ({
  handleRegistrationModal,
  modalOpen = false,
  userDetails = {},
}) => {
  const [isLoading, setIsLoading] = React.useState(false)
  const genderList = [
    {
      value: 'Male',
      label: 'Male',
    },
    {
      value: 'Female',
      label: 'Female',
    },
  ]
  const [checboxLabel, setCheckboxLabel] = React.useState(
    'Terms and Conditions',
  )
  const [value, setValue] = React.useState(null)
  const [center, setCenter] = React.useState({
    lat: 48.8584,
    lng: 2.2945,
  })
  // const [mapCenter, setMapCenter] = React.useState({
  //   ...center,
  // })
  // console.log({ center, value })
  const [
    toggleAddProfilePictureModal,
    setToggleAddProfilePictureModal,
  ] = React.useState(false)
  const handleAddProfilePictureModal = () => {
    handleRegistrationModal(false)
    // if (modalOpen) {
    // }
    // setToggleAddProfilePictureModal(!toggleAddProfilePictureModal)
  }
  const handleTermsAndConditionsCheckBox = (e) => {
    if (e && e.target.checked === true) {
      setCheckboxLabel('Accept terms and conditions')
    } else if (e.target.checked === false) {
      setCheckboxLabel('Terms and Conditions')
    }
  }
  const [gender, setGender] = React.useState('')
  let regUser = localStorage.getItem('newUser')
  const [newUser, setNewUser] = React.useState({
    first_name: '',
    last_name: '',
  })

  const handleChange = (event) => {
    setGender(event.target.value)
  }

  React.useEffect(() => {
    userDetails['location'] = value?.label
    userDetails['longitute'] = center?.lng
    userDetails['lattitude'] = center?.lat
  }, [value, center])

  const [
    identityProofDucumentsModal,
    setIdentityProofDucumentsModal,
  ] = React.useState(false)

  const handleIdentityProofDocumentsModal = () => {
    setIdentityProofDucumentsModal((prev) => !prev)
  }

  const handleUserRegistration = async (e) => {
    userDetails['user_type'] = 'provider'
    // console.log(userDetails)
    localStorage.setItem('isLoading', JSON.stringify(true))
    setIsLoading(true)
    let result = await registerUser('user-register', userDetails)
    setIsLoading(false)
    localStorage.setItem('isLoading', JSON.stringify(false))
    if (result?.data != null && result?.data?.success === true) {
      handleRegistrationModal(false)
      handleIdentityProofDocumentsModal()
      localStorage.setItem('user', JSON.stringify(result?.data?.data))
      console.log(result?.data?.data)
    }
  }

  return (
    <div>
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100%',
          top: 0,
          display: 'flex',
          zIndex: 1500,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />

      <Modal
        open={modalOpen}
        onClose={() => handleRegistrationModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-width">
          <h3 className="fs-24 fw-bold mb-4">Stylist Profile Details</h3>
          <div className="row mt-2">
            <div className="col-12 col-sm-6">
              <div className="birthday">
                <FormHelperText id="input-label" margin="dense">
                  Birthday
                </FormHelperText>
                <OutlinedInput
                  id="location"
                  type="date"
                  placeholder="31/12/1990"
                  name="date_of_birth"
                  onChange={(e) => {
                    userDetails['date_of_birth'] = e.target.value
                  }}
                />
              </div>
            </div>
            <div className="col-12 col-sm-6">
              <div className="gender">
                <FormControl fullWidth>
                  <FormHelperText id="input-label" margin="dense">
                    Gender
                  </FormHelperText>
                  <Select
                    id="gender"
                    value={userDetails?.gender}
                    name="gender"
                    onChange={(e) => {
                      userDetails['gender'] = e.target.value
                    }}
                    // IconComponent={<ExpandMoreIcon />}
                  >
                    {genderList.map((gender) => (
                      <MenuItem key={gender.value} value={gender.value}>
                        {gender.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
          </div>
          <div className="autoplaces-container mt-2">
            <FormHelperText id="input-label" margin="dense">
              Location
            </FormHelperText>
            <GooglePlacesAutocomplete
              selectProps={{
                value,
                onChange: setValue,
                styles: {
                  control: (base, state) => ({
                    ...base,
                    border: '1px solid #08c4bb',
                    borderRadius: '8px !important',
                    // This line disable the blue border
                    boxShadow: state.isFocused ? 0 : 0,
                    '&:hover': {
                      border: '1px solid #08c4bb',
                      borderRadius: '8px !important',
                    },
                  }),
                  input: (provided) => ({
                    ...provided,
                    borderRadius: '8px !important',
                  }),
                  container: (provided) => ({
                    ...provided,
                    // border: '1px solid #08c4bb',
                    borderRadius: '8px !important',
                  }),
                },
              }}
            ></GooglePlacesAutocomplete>
          </div>
          <div className="mt-3">
            <FormHelperText id="input-label" margin="dense" className="mt-2">
              Travel Charges
            </FormHelperText>
            <TextField
              type={'number'}
              value={userDetails.travel_charges}
              name="travel_charges"
              style={{ fontSize: '12px' }}
              placeholder="Travel Charges Per Hour"
              onChange={(e) => {
                if (e.target.value > 0) {
                  userDetails['travel_charges'] = Number(e.target.value)
                }
              }}
            ></TextField>
          </div>
          <FormHelperText id="input-label" margin="dense" className="mt-2">
            About You
          </FormHelperText>
          <div className="bordered-text p-3 text-center">
            <textarea
              className="customer-support-message"
              name="message"
              cols="40"
              rows="7"
              onChange={(e) => {
                userDetails['about'] = e.target.value
              }}
            ></textarea>
          </div>{' '}
          <Button
            onClick={handleUserRegistration}
            disableElevation
            id="btn-primary-no-shadow"
            variant="contained"
            className="mt-3 pointer"
            fullWidth={true}
          >
            Next
          </Button>
        </Box>
      </Modal>
      <IdentityProofDocumentsModal
        handleIdentityProofDocumentsModal={handleIdentityProofDocumentsModal}
        modalOpen={identityProofDucumentsModal}
        component={'sign-up'}
      />
    </div>
  )
}

export default RegistrationModal
